// src/data/navData.ts
import type { NavLink } from '../types/company.types';

export const NAV_LINKS: NavLink[] = [
  { label: 'About Us', path: '/about' },
  {
    label: 'Services',
    path: '/services',
    dropdown: [
      { label: 'Enterprise Retail Solution', path: '/services/enterprise-retail-solutions' },
      { label: 'Enterprise Restaurant Solution', path: '/services/enterprise-restaurant-product' },
      { label: 'Software Development', path: '/services/software-development' },
      { label: 'Embedded System Solutions', path: '/services/embedded-systems' },
      { label: 'ERP, CRM & e-Commerce Solutions', path: '/services/erp-crm' },
      { label: 'Industry Automation Solutions', path: '/services/industry-automation' },
      { label: 'Digital Marketing', path: '/services/digital-marketing' },
    ],
  },
  { label: 'Products', path: '/products' },
  { label: 'Clientele', path: '/clientele' },
  { label: 'Contact Us', path: '/contact' },
];

export const FOOTER_PRODUCTS = [
  'Retail POS Solution',
  'Restaurant POS Solution',
  'Saffron POS (Restaurant)',
  'Retail Billing EzBill POS',
  'e-Bizman Enterprise Management System (ERP)',
  'Drawing Management System (DMS)',
  'Industry Automation Solution',
  'P2P Distance Measuring',
];

export const FOOTER_SERVICES = [
  'Customized Software',
  'Web Application',
  'Mobile Application',
  'Website & Web Portal',
  'Digital Marketing Services',
  'Other Software Solutions',
];
